/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, string, shape, func,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import ReactMarkdown from 'react-markdown';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import LinkBlockStyle from './LinkBlockStyle';

const styles = (theme) => LinkBlockStyle(theme);

class LinkBlock extends PureComponent {
    render() {
        const {
            classes, data, commonClasses, trackEvent,
        } = this.props;
        if (!data) return null;
        const heading = (data.heading || '');
        const message = (data.message || '');
        const link = (data.link || {});
        return (
            <Grid container className={classes.boxLayoutBorder}>
                <Grid item md={9} xs={12}>
                    <Typography variant="h6" gutterBottom>{heading}</Typography>
                    <Grid item md={12} xs={12}>
                        <ReactMarkdown source={message} className={commonClasses.markdown} />
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={3} className={commonClasses.buttonCenter}>
                    <Grid container direction="row" justify="flex-end" alignItems="center">
                        <Grid item xs={12}>
                            <Button
                                onClick={() => {
                                    trackEvent({
                                        eventCategory: data.linking?.tracking_event_category || '',
                                        eventAction: data.linking?.tracking_event_action || '',
                                        eventLabel: data.linking?.tracking_event_label || '',
                                        eventName: 'feature_interaction', // Requird for GA4 feature_click
                                    });
                                }}
                                variant="contained"
                                color="primary"
                                className={commonClasses.button}
                                href={(link.href || '')}
                            >
                                <Typography variant="body2">
                                    <b>{(link.title || '')}</b>
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

LinkBlock.propTypes = {
    classes: object.isRequired,
    commonClasses: object.isRequired,
    data: shape({
        heading: string.isRequired,
        message: string.isRequired,
        link: shape({
            href: string.isRequired,
            title: string.isRequired,
        }).isRequired,
    }).isRequired,
    trackEvent: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(LinkBlock));
